module.exports = __webpack_public_path__ + "img/wave.08d4d611.png";